import { useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";

import { ParentLayout } from "../Assistants/AssistantTools/components/ParentLayout";
import { SectionItem } from "../Assistants/AssistantTools/components/SectionItem";
import { SectionLayout } from "../Assistants/AssistantTools/components/SectionLayout";
import { MainLayout } from "../Assistants/AssistantTools/components/MainLayout";

import { Heading } from "V2.0/common/heading";
import { KeyIcon, MinusCircleIcon } from "@heroicons/react/24/outline";
import APIKeys from "./APIKeys";
import DoNotDisturb from "./DND";

enum Setting {
  API_KEYS = "API Keys",
  // DO_NOT_DISTURB = "Contact DND",
}

const SettingIcon = {
  [Setting.API_KEYS]: <KeyIcon className="size-4" />,
  // [Setting.DO_NOT_DISTURB]: <MinusCircleIcon className="size-4" />,
};

const SettingRegistry = {
  [Setting.API_KEYS]: (props) => <APIKeys {...props} />,
  // [Setting.DO_NOT_DISTURB]: (props) => <DoNotDisturb {...props} />,
};

export default function Settings() {
  const { projectId, settings, fetchSettings, isViewOnly } = useOutletContext();

  const [activeSetting, setActiveSetting] = useState<Setting>(Setting.API_KEYS);

  const sectionItems = useMemo(
    function () {
      return Object.values(Setting).map(function (setting, idx) {
        const isActive = setting === activeSetting;
        const icon = SettingIcon[setting];

        return (
          <SectionItem
            key={idx}
            sectionName={setting}
            isActive={isActive}
            icon={icon}
            onSectionClick={() => setActiveSetting(setting)}
          />
        );
      });
    },
    [activeSetting]
  );

  const mainComponent = useMemo(
    function () {
      return SettingRegistry[activeSetting]({
        workspaceId: projectId,
        settings,
        fetchSettings,
        isViewOnly
      });
    },
    [activeSetting, projectId, settings, fetchSettings, isViewOnly]
  );

  return (
    <div className="h-full w-full py-4 px-8 xl:px-16 mx-auto max-w-8xl flex flex-col gap-y-8">
      <div className="flex items-center gap-x-2 p-4">
        <Heading>Settings</Heading>
      </div>
      <ParentLayout>
        <SectionLayout>{sectionItems}</SectionLayout>
        <MainLayout>{mainComponent}</MainLayout>
      </ParentLayout>
    </div>
  );
}
